<template>
  <v-row>
    <v-col cols="12" sm="12" offset-sm="0">
      <v-card>
        <v-card-title>
          {{ this.title }}
        </v-card-title>
        <v-card-text>Reports from EUREC<sup>4</sup>A campaign </v-card-text>
        <v-container fluid>
          <v-row justify="left" style="overflow-x: scroll;">
            <table class="report">
              <tr v-for="(key, index) in dataGrid" v-bind:key="index">
                <td
                  v-for="(key2, index2) in key"
                  v-html="key2"
                  v-bind:key="index2"
                ></td>
              </tr>
            </table>
          </v-row>
        </v-container>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    reports: [],
    dataGrid: [],
    sdates: [],
    title: "Reports by day and by platform"
  }),
  props: {
    uReport: {
      type: String,
      default: ""
    }
  },
  methods: {
    getResults: function() {
      this.reports = [];

      axios
        .get(
          "https://observations.ipsl.fr/aeris/eurec4aprod/list.php?p=REPORTS"
        )
        .then(response => {
          this.reports = response.data;
          for (let i = 0; i < this.sdates.length; i++) {
            let tm = [];
            if (this.sdates[i] != "")
              tm.push(
                "<strong>" +
                  this.sdates[i].substr(0, 4) +
                  "-" +
                  this.sdates[i].substr(4, 2) +
                  "-" +
                  this.sdates[i].substr(6, 2) +
                  "</strong>"
              );
            else tm.push("");

            for (var p in this.reports) {
              if (this.uReport == "" || p.toString() == this.uReport) {
                if (this.sdates[i] == "") tm.push("<strong>" + p + "</strong>");
                else {
                  let tt = this.reports[p];
                  let rtmp = "";
                  for (var p2 in tt) {
                    let tt2 = tt[p2];
                    for (var p3 in tt2) {
                      if (p3 == this.sdates[i]) {
                        for (let k = 0; k < tt2[p3].length; k++) {
                          if (tt2[p3][k].substring(0, 1) != "~") {
                            var filename = tt2[p3][k].substring(
                              tt2[p3][k].lastIndexOf("/") + 1
                            );
                            rtmp +=
                              '<a href="https://observations.ipsl.fr/aeris/eurec4a-data/' +
                              tt2[p3][k] +
                              '" target="_blank">' +
                              filename +
                              "</a><br />";
                            //rtmp += '<a href="https://observations.ipsl.fr/aeris/eurec4a-data/REPORTS/'+p+'/'+p2+'/'+p3+'/'+tt2[p3][k]+'" target="_blank">' + tt2[p3][k] + '</a><br />';
                          }
                        }
                      }
                    }
                  }
                  tm.push(rtmp);
                }
              }
            }
            this.dataGrid.push(tm);
          }
        });
    }
  },
  mounted: function() {
    if (this.uReport != "") this.title = "Reports by day from " + this.uReport;
    this.sdates = [""];
    let sd = "";
    let a = 0;
    while (sd != "2020-01-07") {
      var date = new Date("2020-02-23");
      let rr = date.setDate(date.getDate() - (a - 1));
      sd = new Date(rr).toISOString().split("T")[0];
      this.sdates.push(sd.replace(/-/gi, ""));
      a++;
    }

    this.getResults();
  },
  computed: {
    getContent() {
      return this.uReport;
    }
  },
  watch: {
    getContent() {
      this.reports = [];
      this.dataGrid = [];
      this.sdates = [];
      this.title = "Reports by day and by platform";
      if (this.uReport != "")
        this.title = "Reports by day from " + this.uReport;
      this.sdates = [""];
      let sd = "";
      let a = 0;
      while (sd != "2020-01-07") {
        var date = new Date("2020-02-23");
        let rr = date.setDate(date.getDate() - (a - 1));
        sd = new Date(rr).toISOString().split("T")[0];
        this.sdates.push(sd.replace(/-/gi, ""));
        a++;
      }

      this.getResults();
    }
  }
};
</script>

<style>
.report {
  border-width: 0px;
  border-style: solid;
  width: 100%;
  border-collapse: collapse;
  margin-left: 0px;
  margin-top: 0px;
  margin-bottom: 10px;
  margin-right: 0px;
}
.report tr:nth-child(even) {
  background: #f8f8f8;
}
.report tr:nth-child(odd) {
  background: #fff;
}
.report tr:first-child {
  background-color: #f0f8ff;
  text-align: center;
}
.report td:first-child {
  text-align: center;
  border-left: 0px;
}
.report td {
  border-width: 1px;
  border-style: solid;
  border-color: #ccc;
  border-collapse: collapse;
  padding: 2px;
  font-size: 9pt;
  color: #555;
  text-align: center;
}
</style>
